import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry, MatSnackBar } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as screenfull from 'screenfull';
import { User } from '../../users/shared/user';
import { NavService } from '../nav.service';
import { NavItem } from './nav-item';
import { NavList } from './nav-list';
import { ObjectObservable } from "../../shared/base/object-observable";
import { APPCONFIG } from "../../config";
import { UserService } from "../../users/shared/user.service";
import { AuthService } from "../auth.service";
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from "../../shared/message";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit{

  @Input() items: NavItem[];
  @Input() themes: String[];
  @ViewChild('innerNav') sideNav;
  @Input() userObservable: ObjectObservable<User>;
  isFullscreen = false;
  private AppConfig: any;

  constructor(private service: NavService,
              private authService: AuthService,
              private router: Router,
              private userService: UserService,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer,
              public snackBar: MatSnackBar) {
    iconRegistry.addSvgIcon(
      'slack',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/slack.svg'));
  }


  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

  onClick(item: NavItem, event) {
    this.router.navigate(item.commands, (item.route ? {relativeTo: item.route} : {}));
  }

  onLessonClick(item: NavItem, event) {
    this.onClick(item, event);
  }

  isActivated(list: NavList, item: NavItem) {
    if (list.activated == null || item.commands == null) {
      return false;
    }
    return list.activated.toString() === item.commands.toString();
  }

  toggleFullscreen() {
    if (screenfull.enabled) {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    }
  }

  closeSideNav() {
    return this.sideNav.close();
  }

  openSideNav() {
    return this.sideNav.open();
  }

  get navActions() {
    return this.service.navActions;
  }

  get navList() {
    return this.service.navList;
  }

  get subList() {
    return this.service.subList;
  }

  get subOnly() {
    return this.service.navList == null || this.service.subOnly;
  }

  get title() {
    return this.service.title;
  }

  get lectureTitle() {
    return this.service.lectureTitle;
  }

  get actions() {
    return this.service.actions;
  }

  get articleActions() {
    return this.service.articleActions;
  }

  get isMultipleRow() {
    return this.title && this.actions;
  }

  get hasInnerNav() {
    return !!this.subList;
  }

  get lectureAction() {
    return this.service.lectureAction;
  }

  get lecturePublic() {
    return this.service.lecturePublic;
  }

  get slackUrl() {
    return this.service.slackUrl;
  }

  get userDetail() {
    return this.service.userDetail;
  }

  get isAuthenticated() {
    return this.authService.isAuthenticated;
  }

  async onSubmit(event) {
    try {
      this.AppConfig.theme = event.target.value;

      if (this.authService.isAuthenticated) {
        await this.userService.update(this.userObservable.$ref.key, Object.assign({}, this.authService.user, {
          colorTheme: event.target.value
        }));
      }
    } catch (e) {
      this.snackBar.open(MESSAGE_COMMON_ERROR);
    }
  }
}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/navbar/navbar.component.ts